// extracted by mini-css-extract-plugin
export default {"products":"Qu-z","card":"Ru-z","oosMessaging":"Su-z"};